import React, { Suspense, useContext } from 'react';
import { Canvas } from 'react-three-fiber';
import { useContextBridge, OrbitControls } from '@react-three/drei';

import { ConfigContext } from './config';
import { ShapeContext } from './shapes';
import Scene from './Scene';
import Effects from './Effects';
import Controls from './Controls';
import Download from './Download';
import Background from './Background';

/**
 * original, 2015 non-react version:
 * https://codepen.io/cubeghost/full/GooRZj
 */

const App = () => {
  const ContextBridge = useContextBridge(ConfigContext, ShapeContext);
  const { useConfig } = useContext(ConfigContext);
  const backgroundColor = useConfig('backgroundColor');

  return (
    <>
      <Controls />
      <div style={{ backgroundColor: backgroundColor, width: '100vw', height: '100vh', position: 'fixed' }}>
        <div className="canvas">
          <Canvas camera={{ position: [0, 0, 20] }} gl={{ preserveDrawingBuffer: true }}>
            <ContextBridge>
              <ambientLight intensity={0.75} />
              <pointLight position={[10, 10, 10]} />
              <OrbitControls />
              <Download />
              <Suspense fallback={null}>
                <Background />
                <Effects />
                <Scene />
              </Suspense>
            </ContextBridge>
          </Canvas>
        </div>
        <a className="sandbox-link" href="https://codesandbox.io/s/r3f-kaleidoscope-tool-4n9by">
          Open Sandbox
        </a>
      </div>
    </>
  );
};

export default App;
